import React from 'react'
import { connect } from 'react-redux'
import { LoginPage as LoginPageComponent } from '../LoginPage'
import { Form } from '../../AuthNative'
import { GoogleButton } from '../../AuthGoogle'
import { FirefoxButton } from '../../AuthFirefox'

const getErrorMessage = (state) => {
  const error = state.googleAuth.error || state.login.error

  return error ? error.message : state.login.errorHtml
}

const mapStateToProps = (state, params) => {
  const dict     = state.localization.dictionary.login
  const errorMsg = getErrorMessage(state)
  const message  = state.login.messageHtml

  return {
    dict,
    errorMsg,
    message
  }
}

const onSuccess = (response) => {
  // Server sometimes returns a url in the response
  if (response.locationUrl) {
    window.location.assign(response.locationUrl)
  }
}

const onError = (error) => {
  // Captcha or CSRF error
  if (error.id === 5107) {
    // Show login with appropriate error message
    window.location.assign('/login?e=24')
  }

  // Google authed but not recognized account. Create it?
  if (error.id === 5104) {
    window.location.assign(`/signup_interim?email=${user.email}`)
  }
}

const LoginPage = (props) => {
  return (
    <LoginPageComponent
      dict={ props.dict }
      messageHtml={ props.message }
      errorHtml={ props.errorMsg }
      top={
        <div>
          <GoogleButton
            onError={ onError }
            onSuccess={ onSuccess } />
          <FirefoxButton />
        </div>
      }
      bottom={
        <Form
          onError={ onError }
          onSuccess={ onSuccess } />
      }
    />
  )
}

const LoginPageConnected = connect(
  mapStateToProps
)(LoginPage)

export {
  LoginPageConnected as LoginPage
}



// WEBPACK FOOTER //
// ./client/Modules/LoginPage/containers/LoginPage.js